import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  animationObjects: [],
};

const animationSlice = createSlice({
  name: 'animation',
  initialState,
  reducers: {
    addAnimationObject: (state, action) => {
      let finalActiveState = true;
      if (action.payload?.isAnimationActive !== undefined) {
        finalActiveState = action.payload.isAnimationActive;
      } else if (action.payload?.isActive !== undefined) {
        finalActiveState = action.payload.isActive;
      } else if (action.payload?.events && Array.isArray(action.payload.events)) {
        // If there's an event to play the animation, don't start it automatically
        const hasPlayAnimationEvent = action.payload.events.some(
          (e) => e.action === 'Play Animation'
        );
        if (hasPlayAnimationEvent) {
          finalActiveState = false;
        }
      }

      state.animationObjects.push({
        ...action.payload,
        isActive: finalActiveState,
      });
    },
    removeAnimationObject: (state, action) => {
      state.animationObjects = state.animationObjects.filter(
        (obj) => obj.id !== action.payload
      );
    },
    updateAnimationObject: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.animationObjects.findIndex((obj) => obj.id === id);

      if (index !== -1) {
        // keep id, name, type as they are
        state.animationObjects[index] = {
          ...state.animationObjects[index],
          ...updates,
          id: state.animationObjects[index].id,
          name: state.animationObjects[index].name,
          type: state.animationObjects[index].type,
        };
      }
    },
    cleanAllAnimationObjects: (state) => {
      state.animationObjects = [];
    },
    setAnimationObjectsHistory: (state, action) => {
      state.animationObjects = action.payload || [];
    },
  },
});

export const {
  addAnimationObject,
  removeAnimationObject,
  updateAnimationObject,
  cleanAllAnimationObjects,
  setAnimationObjectsHistory,
} = animationSlice.actions;
export default animationSlice.reducer;
